const actionPanelButtonsConstantsAR = {
  createActionPanel: 'إنشاء',
  backActionPanel: 'رجوع',
};

export default actionPanelButtonsConstantsAR;
